export default __webpack_public_path__ + "images/62f2a7a701.svg";